import React from "react";
import { useWaitlistCount } from "@/hooks/useWaitlistCount";

const Stats = () => {
  const count = useWaitlistCount();
  const stats = [
    { v: count === null ? "—" : count.toLocaleString(), l: "Earners on the waitlist" },
    { v: "42M+", l: "Americans participate in gig work" },
    { v: "0", l: "Hidden fees. Ever." },
    { v: "6+", l: "Gig platforms connected" },
  ];
  return (
    <section className="py-20 border-y border-white/5" data-testid="stats-ribbon">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 grid grid-cols-2 md:grid-cols-4 gap-y-10 gap-x-6">
        {stats.map((s, i) => (
          <div key={i} className="text-center md:text-left" data-testid={`stat-${i}`}>
            <div className="font-display text-4xl lg:text-5xl font-black bg-gradient-to-br from-white to-white/50 bg-clip-text text-transparent">
              {s.v}
            </div>
            <div className="mt-2 font-mono-c text-[10px] uppercase tracking-[0.2em] text-white/40">
              {s.l}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Stats;
